module.exports = __webpack_public_path__ + "static/img/锐捷Ruijie天蝎BE72Pro.419df16b.png";